export default __webpack_public_path__ + "static/radovi4-2e0b4de27f05205fe024fb091e69da16.png";